import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import { mutations } from "./mutations";
import { actions } from "./actions";

Vue.use(Vuex);

const getDefaultState = () => ({
	status: {
		time: 					null,
		success: 				true,
		status_message: "OK",
	},
	token: 									null,
	user: 									null,
	lastSignedAt: 					null,
	recentMessages: 				[],
	recentTlsCases: 				[],
	recentServiceTlsCases: 	[],
	recentGroups: 					[],
});

// initial state
const state = getDefaultState();

const resetState = (state) => {
	Object.assign(state, getDefaultState());
};

const getters = {
	isAuthenticated: state => !!state.token,
	isAdmin: state => !!(state.user && state.user.tls_admin),
};

export const store = new Vuex.Store({
	state,
	actions,
	getters,
	mutations: { ...mutations, resetState },
	plugins: [createPersistedState()]
});